import { createIsOnetrustGroupOptedInSelector } from '@calendly/onetrust/redux'
import { createSelector } from 'reselect'

import { isEmbeddedSelector } from 'selectors/embed'

const shouldHideSelector = ({ gdpr }) => gdpr.isHidden

export const shouldEnforceOptInSelector = ({ event_type: eventType }) => (
  eventType && eventType.has_active_payment_method
)

const shouldHideOnetrustSelector = createSelector(
  shouldHideSelector,
  isEmbeddedSelector,
  (shouldHide, isEmbedded) => Boolean(shouldHide && isEmbedded)
)

export const isCookiesAllowedSelector = (group = null) => createSelector(
  shouldHideOnetrustSelector,
  createIsOnetrustGroupOptedInSelector(group),
  (isOnetrustHidden, isOnetrustGroupOptedIn) => (isOnetrustHidden || isOnetrustGroupOptedIn)
)
